import { SvgIconComponent } from '@material-ui/icons';
import { MenuItem, makeStyles, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

export interface MenuItemProps {
  name: string;
  path?: string;
  Icon?: SvgIconComponent;
  onClick?: () => void;
  externalPath?: string;
  index?: number;
  addBorder?: boolean;
}

const useStyles = makeStyles(() => ({
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    color: 'black',
    textDecoration: 'none',
  },
  menuName: {
    fontSize: '13px',
  },
  menuIcon: {
    height: '20px',
    marginRight: '10px',
  },
  borderTop: {
    borderTop: '1px solid #d3d4d5',
  },
}));

export const Item: React.FC<MenuItemProps> = ({
  name,
  path = '',
  Icon,
  onClick = () => {},
  externalPath = '',
  addBorder = false,
  index,
}) => {
  const classes = useStyles();

  const menuItemClasses = `${classes.menuItem} ${addBorder ? classes.borderTop : ''}`;

  if (externalPath) {
    return (
      <MenuItem href={externalPath} target="_blank" component="a" className={menuItemClasses}>
        {Icon && <Icon className={classes.menuIcon} />}
        <Typography className={classes.menuName}>{name}</Typography>
      </MenuItem>
    );
  } else if (path) {
    return (
      <MenuItem key={index}>
        <Link to={path} className={menuItemClasses}>
          {Icon && <Icon className={classes.menuIcon} />}
          <Typography className={classes.menuName}>{name}</Typography>
        </Link>
      </MenuItem>
    );
  } else {
    return (
      <MenuItem key={index} onClick={onClick} className={menuItemClasses}>
        {Icon && <Icon className={classes.menuIcon} />}
        <Typography className={classes.menuName}>{name}</Typography>
      </MenuItem>
    );
  }
};
